import { render, staticRenderFns } from "./Isci.vue?vue&type=template&id=88664e18&scoped=true"
import script from "./Isci.vue?vue&type=script&lang=js"
export * from "./Isci.vue?vue&type=script&lang=js"
import style0 from "./Isci.vue?vue&type=style&index=0&id=88664e18&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88664e18",
  null
  
)

export default component.exports